import { merge } from 'lodash-es';
import router from '../../router';

const prefixSymbol = '-';

// @todo - make router a param

export default {
  namespaced: true,
  state: {
    componentParams: {}
  },
  mutations: {
    setComponentParams (state, payload) {
      // console.log('setComponentParams', payload);
      // We want to keep a list for every prefix, so we know exactly which params to replace
      state.componentParams[createPrefix(payload.id)] = payload.params;
    },
    setParams (state, payload) {
      // console.log('setParams', payload);
      // The params as they appear in the URL
      state.componentParams = mapToPrefix(decodeParams(payload), prefixSymbol);
    }
  },
  getters: {
    getComponentParams: (state) => (id) => {
      // Get the params as they appear in the url, but without the prefix
      return state.componentParams[createPrefix(id)] || {};
    }
  },
  actions: {
    updateParams ({ commit, state }, payload) {
      // Update the local params
      commit('setComponentParams', payload);

      // Flatten the list of params to render
      const queryParams = merge({}, ...Object.keys(state.componentParams).map(key => {
        if (key === prefixSymbol) {
          return state.componentParams[key];
        } else {
          return addPrefix(state.componentParams[key], key);
        }
      }));

      // Finally, add the params to the route
      router.replace({
        ...router.currentRoute,
        query: encodeParams(queryParams)
      }).catch((e) => {
        console.warn(e);
      });
    },
    startListening ({ commit }) {
      router.beforeHooks.push((to, from, next) => {
        commit('setParams', to.query);
        next();
      });
    },
    updateOnce ({ commit }) {
      commit('setParams', router.currentRoute.query);
    }
  }
};

const createPrefix = (id) => {
  return id ? id + prefixSymbol : prefixSymbol;
};

const encodeParams = (params = {}) => {
  return Object.keys(params).reduce((obj, key) => {
    var value = params[key]
    if (value !== undefined && !(Array.isArray(value) && value.length === 0)) {
      obj[key] = JSON.stringify(params[key]);
    }
    return obj;
  }, {});
};

const decodeParams = (params = {}) => {
  return Object.keys(params).reduce((obj, key) => {
    try {
      obj[key] = JSON.parse(params[key]);
    } catch (e) {
      console.warn(e);
    }
    return obj;
  }, {});
};

/**
 * Takes the map and groups the values with a shared prefix
 * Values that have no prefix are grouped too under the prefix symbol name
 *
 * Example:
 * {
 *    foo_bar: 123,
 *    foo_baz: 321,
 *    leet: 1337
 * }
 *
 * Becomes:
 * {
 *    foo: {
 *      bar: 123,
 *      baz: 312
 *    },
 *    _: {
 *      leet: 1337
 *    }
 * }
 * @param {Object} params
 * @param {String} prefixSymbol
 */
const mapToPrefix = (params, symbol) => {
  return Object.keys(params).reduce((obj, key) => {
    let prefix = symbol;
    let origKey = key;
    const prefixIndex = key.indexOf(symbol);
    if (prefixIndex > 0) {
      prefix = key.substring(0, prefixIndex + 1);
      origKey = key.substring(prefixIndex + 1);
    }
    if (!obj[prefix]) {
      obj[prefix] = {};
    }
    obj[prefix][origKey] = params[key];
    return obj;
  }, {});
};

/**
 * Adds the prefix to every property key in the object
 * @param {Object} srcObj
 * @param {String} prefix
 */
const addPrefix = (srcObj, prefix) => {
  return Object.keys(srcObj).reduce((newObj, key) => {
    newObj[(prefix + key)] = srcObj[key];
    return newObj;
  }, {});
};
